export enum AppPref {
	HELP_URL = 'app.helpUrl',
}

export enum AppCombinedMenuItemsSection {
	MAIN = 'main',
	SYSTEM = 'system',
	TOOLS = 'tools',
	USER = 'user',
	SIGN_OUT = 'signOut',
}
